// Store links have to follow the device, not the browser: sending an Android
// visitor to the App Store is a dead end. Two traps make user-agent sniffing
// less obvious than it looks:
//
//   * iPadOS 13+ reports itself as "Macintosh; Intel Mac OS X" with no iPad
//     anywhere in the string. Touch support is the only reliable way to tell
//     an iPad from a Mac.
//   * Some Android builds mention "Linux" and "Safari" but never "iPhone", so
//     Android has to be checked first and matched on its own name.
//
// Desktop and anything unrecognized keep the App Store link, which is what the
// site has always used and renders fine in a desktop browser.

export const APP_STORE_URL =
  'https://apps.apple.com/us/app/field-facts-baseball/id1352780085';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.fieldfacts.baseball';

/** @returns {'android' | 'ios' | 'other'} */
export const detectPlatform = (userAgent, maxTouchPoints = 0) => {
  const ua = typeof userAgent === 'string' ? userAgent : '';

  if (/Android/i.test(ua)) {
    return 'android';
  }

  if (/iPhone|iPad|iPod/i.test(ua)) {
    return 'ios';
  }

  // iPadOS 13+ masquerading as a Mac. A real Mac reports maxTouchPoints 0.
  if (/Macintosh/i.test(ua) && Number(maxTouchPoints) > 1) {
    return 'ios';
  }

  return 'other';
};

export const storeUrlForPlatform = (platform) =>
  platform === 'android' ? PLAY_STORE_URL : APP_STORE_URL;

export const isMobilePlatform = (platform) =>
  platform === 'android' || platform === 'ios';

export const currentPlatform = () => {
  if (typeof navigator === 'undefined') {
    return 'other';
  }
  return detectPlatform(navigator.userAgent, navigator.maxTouchPoints);
};

export const currentStoreUrl = () => storeUrlForPlatform(currentPlatform());
